<template>
  <div v-if="data != undefined">
    <h4>{{$t('models.project_lead.crawled_infos.more_infos')}}</h4>
    
    <div class="sidebar">
      <div class="company-logo" v-if="data.logo">
        <img :src="data.logo" alt="">
      </div>
      <div class="social-networks">
        <div v-if="has(data, 'facebook.handle')">
          <a :href="'http://facebook.com/' + data.facebook.handle" target="_blank">
            <img src="../../../assets/icons/icon-fb.svg" alt="">
          </a>
        </div>
        <div v-if="has(data, 'twitter.handle')">
          <a :href="'http://twitter.com/' + data.twitter.handle" target="_blank">
            <img src="../../../assets/icons/icon-twitter.svg" alt="">
          </a>
        </div>
        <div v-if="has(data, 'linkedin.handle')">
          <a :href="'http://linkedin.com/' + data.linkedin.handle" target="_blank">
            <img src="../../../assets/icons/icon-linkedin.svg" alt="">
          </a>
        </div>
        <div v-if="has(data, 'crunchbase.handle')">
          <a :href="'http://crunchbase.com/' + data.crunchbase.handle" target="_blank">
            <img src="../../../assets/icons/icon-clearbit.svg" alt="">
          </a>
        </div>
      </div>
    </div>

    <div class="content">
      <crawled-info label="name" :value="data.name" v-if="has(data,'name')"></crawled-info>
      <!-- <crawled-info label="domain" :value="data.domain" v-if="has(data,'domain')"></crawled-info> -->
      
      <div class="crawled-info--wrapper" v-if="has(data,'domain')">
        <div class="crawled-info--label">
          {{$t('models.project_lead.crawled_infos.domain')}}
        </div>
        <div class="crawled-info--value">
          <a :href="'http://' + data.domain" target="_blank">
            {{data.domain}}
          </a>
        </div>
      </div>
      
      
      <crawled-info label="foundedYear" :value="data.foundedYear" v-if="has(data,'foundedYear')"></crawled-info>
      <crawled-info label="country" :value="data.country" v-if="has(data,'country')"></crawled-info>
      <crawled-info label="location" :value="data.location" v-if="has(data,'location')"></crawled-info>
      <crawled-info label="description" :value="data.description" v-if="has(data,'description')"></crawled-info>
      
      <crawled-info label="category" :value="category" v-if="has(data,'category')"></crawled-info>
      <crawled-info label="tags" :value="tags" v-if="has(data,'tags')"></crawled-info>
      
      <div class="crawled-info--wrapper" v-if="has(data,'site.emailAddresses')">
        <div class="crawled-info--label">
          {{$t('models.project_lead.crawled_infos.emailAddresses')}}
        </div>
        <div v-for="item in data.site.emailAddresses" :key="item" class="crawled-info--value">
          <a :href="'mailto:' + item">
            {{item}}
          </a>
        </div>
      </div>

      <div class="crawled-info--wrapper" v-if="has(data,'site.phoneNumbers')">
        <div class="crawled-info--label">
          {{$t('models.project_lead.crawled_infos.phoneNumbers')}}
        </div>
        <div v-for="item in data.site.phoneNumbers" :key="item" class="crawled-info--value">
          <a :href="'tel:' + item">
            {{item}}
          </a>
        </div>
      </div>

      <div class="crawled-info--wrapper" v-if="has(data,'metrics')">
        <div class="crawled-info--label">
          {{$t('models.project_lead.crawled_infos.metrics')}}
        </div>
        <div v-for="(item,key) in data.metrics" v-if="item" :key="item" class="crawled-info--value">
          {{key}}: {{item}}
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import CrawledInfo from './CrawledInfo'

export default{
  props: {
    item: {}
  },
  components: { CrawledInfo },
  computed: {
    data(){
      if(this.item.meta_information != undefined){
        if(this.item.meta_information.clearbit != undefined){
          return this.item.meta_information.clearbit.content.company
        }
      }else{
        return {}
      }
    },
    tags(){
      return this.data.tags.join(', ')
    },
    phoneNumbers(){
      return this.data.site.phoneNumbers.join(' ')
    },
    category(){
      let str = ''
      if(this.data.category.sector){str += this.data.category.sector + ', '}
      if(this.data.category.industryGroup){str += this.data.category.industryGroup + ', '}
      if(this.data.category.industry){str += this.data.category.industry + ', '}
      if(this.data.category.subIndustry){str += this.data.category.subIndustry}
      return str
    }
  },

  methods: {
    has(obj, key) {
      return _.get(obj,key)
    }
  }
}
</script>
<style lang="scss" scoped>
h4{
  font-weight: 400;
  margin-top: 40px;
  margin-bottom: 25px;
}
.sidebar{
  float: right;
  text-align: right;
  max-width: 150px;
  @include respond-to("medium"){
    float: none;
    text-align: center;
    max-width: none;
    margin-bottom: 20px;
    div{
      display: inline-block;
    }
  }
  .company-logo,
  a{
    display: inline-block;
    margin-bottom: 15px;
  }
  img{
    max-width: 100%;
  }
}
.grid{
  margin-bottom: -1em;
  margin-left: -1em;
  margin-right: -1em;
}
.one-third{
  background: #f2f2f2;
  padding: 2em 1em;
}
.two-third{
  padding: 2em;
}

.linkedin_link{
  text-decoration: none;
}

.linkedin_link .crawled-info--value{
    color: #2e7bae;
    text-decoration: none;
}

</style>
<style lang="scss">
.crawled-info--wrapper{
  // display: flex;
  // clear: both;
  overflow: hidden;
  margin-bottom: 15px;
}
.crawled-info--label{
  word-break: break-all;
  width: 25%;
  float: left;
}
.crawled-info--value{
  // width: 70%;
  margin-left: 25%;
  padding-left: 25px;
  a{
    color: #2e7bae;
    text-decoration: none;
  }
}
@include respond-to("medium"){
  .crawled-info--label{
    width: auto;
    float: none;
  }
  .crawled-info--value{
    margin-left: 0;
    padding-left: 0;
  }

}
</style>



// WEBPACK FOOTER //
// CrawledInfos.vue?22be124c